import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-two-rtl',
  templateUrl: './template-two-rtl.component.html',
  styleUrls: ['./template-two-rtl.component.css']
})
export class TemplateTwoRtlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
